export const PLUGIN_KIND_CONTENT = 'content';
export const PLUGIN_KIND_HIDDEN = 'hidden';

export const PLUGIN_KEYS = {
  root: {
    topBar: 'root.topBar',
    contentTabs: 'root.contentTabs',
  },
  // content: {
  //   blox: 'content.blox',
  //   sound: 'content.sound',
  // },
};
